export function view(value) {
  return value ? 'SubmitAction' : 'ReviewAction'
}
